import styled from 'styled-components';

interface ImageContainerProps {
  paddingTop?: string;
}

export const ImageContainer = styled.div<ImageContainerProps>`
  min-height: 180px;
  height: calc(calc(100vw * 9) / 19);
  
  @media (min-width: 575px) {
    width: 550px;
    height: calc(calc(550px * 9) / 19);
  }

  max-height: 480px;
  position: relative;
  padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '0px')};

  img {
    position: absolute;
    object-fit: cover;
    height: 100%;
    left: 0;
    top: 0;
  }
`;
